import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContractingStateEnum } from 'v3/data/store/contracting/enums';
import { ContractingListType, ContractingType, FiltersType } from 'v3/data/store/contracting/types';
import { paymentInitialState } from 'v3/data/store/payment/state';
import { PaymentDataType } from 'v3/data/store/payment/types';
import { IStoreItem } from 'v3/data/store/stores/types';

export const paymentSlice = createSlice({
  name: 'payment',
  initialState: paymentInitialState,
  reducers: {
    setPaymentList: (state, action: PayloadAction<ContractingListType>) => {
      state.list = action.payload;
      return state;
    },

    setPaymentData: (state, action: PayloadAction<PaymentDataType>) => {
      state.paymentData = action.payload;
      return state;
    },

    setFilters: (state, action: PayloadAction<FiltersType>) => {
      state.filter = action.payload;
      return state;
    },
    setStoreIdsList: (state, action: PayloadAction<string[]>) => {
      state.filter.storeIds = action.payload;
      return state;
    },
    setFilterCurrentPage: (state, action: PayloadAction<number>) => {
      state.filter.page = action.payload;
      return state;
    },
    setFilterRowsPerPage: (state, action: PayloadAction<number>) => {
      state.filter.rowsPerPage = action.payload;
      return state;
    },
    setFilterRowsToSkip: (state, action: PayloadAction<number>) => {
      state.filter.page = action.payload;
      return state;
    },
    setContractingKey: (state, action: PayloadAction<string>) => {
      state.contractingKey = action.payload;
      return state;
    },
    setPaymentState: (state, action: PayloadAction<ContractingStateEnum>) => {
      state.contractingState = action.payload;
      return state;
    },
    setPaymentSelected: (state, action: PayloadAction<ContractingType>) => {
      state.selectedContracting = action.payload;
      return state;
    },
    setTokenValid: (state, action: PayloadAction<boolean>) => {
      state.tokenValid = action.payload;
      return state;
    },
    setTimeRemaining: (state, action: PayloadAction<string>) => {
      state.timeRemaining = action.payload;
      return state;
    },
    setContractSignDate: (state, action: PayloadAction<string>) => {
      state.selectedContracting.contractSignDate = action.payload;
      return state;
    },
    setStoreIdsListFilter: (state, action: PayloadAction<string[]>) => {
      state.filter.storeIds = action.payload;
      return state;
    },

    setTotalContractings: (state, action: PayloadAction<number>) => {
      state.generateAllContractingList.totalContractings = action.payload;
      return state;
    },
    setAllStoresIds: (state, action: PayloadAction<IStoreItem[]>) => {
      state.generateAllContractingList.initialStoreIds = action.payload;
      return state;
    },

    setInitialStoreIdsRequest: (state, action: PayloadAction<boolean>) => {
      state.generateAllContractingList.initialStoreIdsRequest = action.payload;
      return state;
    },
  },
});
